const Payment = {

    // FIELDS
    "invoice": "Invoice",
    "mode": "Mode",
    "payment_date": "Date",
    "payment_amount": "Amount",
    "reference_no": "Reference Number",
    "remark": "Remark",
    "search": "Search",

    // BUTTON
    "confirm": "Confirm",

    // PAGE HEADER
    "payment": "Payment",

    // TOOLTIP
    "approve": "Approve",
    "reject": "Reject",

    // SWEET ALERT
    "approve_confirm_text": "Are You Sure Want To Approve Payment?",
    "reject_confirm_text": "Are You Sure Want To Reject Payment?",
    "status": "Status",
    "status_text": "Status Successfully Changed",

    // ERROR
    "error_invoice": "Select Invoice",
    "error_positive": "Enter Only Positive Amount",
    "error_mode": "Select Payment Mode",
    "error_payment_date": "Choose Date",
    "error_payment_amount": "Enter Amount",
    "error_reference_no": "Enter Reference Number",
    "error_remark": "Enter Remark",

    // TABLE HEADER
    "table_invoice": 'INVOICE',
    "table_payment_mode": "MODE",
    "table_payment_date": "DATE",
    "table_payment_amount": "AMOUNT",
    "table_txn_id": "TRANSACTION ID",
    "table_remark": "REMARK",
    "table_status": "STATUS",
}

export default Payment;